import { CONTEXT_ACTION_TYPES } from './../actions/context.actions';
import { MainContext } from './../../models/main-context.model';
import { StoreAction } from '../../models/rootState.model';



const InitialState: MainContext = {
  entity: null,
  loaded: false,
  loading: false
};

export function MainContextReducer(
  state = InitialState,
  action: StoreAction
): MainContext {
  switch (action.type) {

    case CONTEXT_ACTION_TYPES.CONTEXT_INIT: {
      return {
        ...state,
        loading: true
      };
    }

    case CONTEXT_ACTION_TYPES.CONTEXT_INIT_SUCCESS: {
      return {
        ...state,
        entity: action.payload,
        loaded: true,
        loading: false
      };
    }

    case CONTEXT_ACTION_TYPES.CONTEXT_INIT_FAIL: {
      return {
        ...state,
        loading: false
      };
    }

    case CONTEXT_ACTION_TYPES.DATA_UPDATED:
    case CONTEXT_ACTION_TYPES.USER_CHANGED_CONTEXT: {
      return {
        ...state,
        entity: action.payload
      };
    }

    case CONTEXT_ACTION_TYPES.CONTEXT_IMAGE_CHANGED: {
      const entity = state.entity;
      entity.photo_url = action.payload?.photo_url;
      return {
        ...state,
        entity
      };
    }

    case CONTEXT_ACTION_TYPES.RESSET: {
      return {
        ...state,
        entity: null,
        loaded: false
      };
    }

    default: {
      return state;

    }

  }
}
